import { youthEditApprovePermissions } from '@modules/youthProfile/constants';
import { newPermissions } from '@shared/newPermissions';

export enum MemberType {
  Youth = 'youth',
  Adult = 'adult',
}

/**
 * The four rank requirement editor/approver permissions, from the positions
 * assignable to youth. They open a youth's advancement details for any viewer.
 *
 * Deliberately kept separate from `youthEditApprovePermissions`: that array is
 * also what gates the youthProfile module's own route, so widening it there
 * would loosen a screen this feature does not own
 */
export const unitRosterYouthDetailsPermissions: string[] = [
  ...youthEditApprovePermissions,
];

/**
 * The unit-wide advancement roles: Advancement Editor (which Youth Leadership
 * also carries), Advancement Approver and Advancement Awarder.
 */
export const unitAdvancementPermissions: string[] = [
  newPermissions.EDIT_ADVANCEMENTS,
  newPermissions.APPROVE_ADVANCEMENTS,
  newPermissions.AWARD_ADVANCEMENTS,
];

export const PRIORITY_POSITIONS = [
  'Scoutmaster',
  'Venturing Crew Advisor',
  'Skipper',
  'Cubmaster',
  'Committee Chair',
  'Committee Chairman',
  'Chartered Organization Rep.',
  'Youth Member',
] as const;

export const PRIORITY_POSITION_INDEX: ReadonlyMap<string, number> = new Map(
  PRIORITY_POSITIONS.map((p, i) => [p, i]),
);

export interface RosterLiteState {
  groupBy?: string;
}

export const initialState: RosterLiteState = {};
